import React, { createContext, useContext, useState } from 'react';

const ProductContext = createContext();

const productsData = {
  popular: [
    { id: 1, artist: 'Panagiotis', title: 'Drizzy', image: '/image/1.jpeg', audio: '/audio/1.mpeg', price: 1450, status: 'buy' },
    { id: 2, artist: 'Ethan', title: 'Sniper', image: '/image/2.jpeg', audio: '/audio/2.mpeg', price: 1500, status: 'sold' },
    { id: 3, artist: 'Dustin', title: 'Speeding', image: '/image/3.jpeg', audio: '/audio/3.mpeg', price: 1400, status: 'sold' },
    { id: 4, artist: 'OTto', title: 'Fairy', image: '/image/4.jpeg', audio: '/audio/4.mpeg', price: 1500, status: 'buy' },
    { id: 5, artist: 'Alex', title: 'Boom Bap', image: '/image/5.jpeg', audio: '/audio/5.mpeg', price: 1700, status: 'buy' },
    { id: 6, artist: 'Stera', title: 'Stera', image: '/image/6.jpeg', audio: '/audio/6.mpeg', price: 1650, status: 'sold' },
    { id: 7, artist: '2253', title: 'Mayaa', image: '/image/7.jpeg', audio: '/audio/7.mpeg', price: 1450, status: 'sold' },
    { id: 8, artist: 'Sophie', title: 'Synth Wave', image: '/image/8.jpeg', audio: '/audio/8.mpeg', price: 1750, status: 'sold' },
    { id: 9, artist: 'James', title: 'Rasta Road', image: '/image/9.jpeg', audio: '/audio/9.mpeg', price: 1400, status: 'buy' },
    { id: 10, artist: 'Nathan', title: 'Play Around', image: '/image/10.jpeg', audio: '/audio/10.mpeg', price: 1650, status: 'sold' },
    { id: 11, artist: 'Sahil', title: 'Reasons', image: '/image/11.jpeg', audio: '/audio/11.mpeg', price: 1600, status: 'sold' },
    { id: 12, artist: 'Flez', title: 'Plugg Type Beat', image: '/image/12.jpeg', audio: '/audio/12.mpeg', price: 1450, status: 'buy' },
    { id: 13, artist: 'Liam', title: 'Afro Beat', image: '/image/13.jpeg', audio: '/audio/13.mpeg', price: 1600, status: 'buy' },
    { id: 14, artist: 'Mia', title: 'Reggae Roots', image: '/image/14.jpeg', audio: '/audio/14.mpeg', price: 1550, status: 'buy' },
    { id: 15, artist: 'Rob', title: 'Cheo', image: '/image/15.jpeg', audio: '/audio/15.mpeg', price: 1450, status: 'sold' },
    { id: 16, artist: 'Chris', title: 'Enchiladas', image: '/image/16.jpeg', audio: '/audio/16.mpeg', price: 1500, status: 'sold' },
    { id: 17, artist: 'Mason', title: 'Tech House', image: '/image/17.jpeg', audio: '/audio/17.mpeg', price: 1800, status: 'buy' },
    { id: 18, artist: 'Ude', title: 'Influecia', image: '/image/18.jpeg', audio: '/audio/18.mpeg', price: 1400, status: 'sold' },
  ],
  latest: [
    { id: 19, artist: 'James', title: 'Hot-Kit', video: '/video/vid1.mp4', price: 1900, status: 'buy' },
    { id: 20, artist: 'Sophie', title: 'Night Drive', video: '/video/vid2.mp4', price: 2000, status: 'sold' },
    { id: 21, artist: 'Lucas', title: 'Cyber Punk', video: '/video/vid3.mp4', price: 2100, status: 'buy' },
    { id: 22, artist: 'Emma', title: 'Retro Wave', video: '/video/vid4.mp4', price: 1950, status: 'buy' },
  ],
};

export const ProductProvider = ({ children }) => {
  const [searchQuery, setSearchQuery] = useState('');
  
  const filterProducts = (query) => {
    setSearchQuery(query.toLowerCase());
  };

  const filteredPopular = searchQuery
    ? productsData.popular.filter(
        (product) =>
          product.artist.toLowerCase().includes(searchQuery) ||
          product.title.toLowerCase().includes(searchQuery)
      )
    : productsData.popular;

  const filteredLatest = searchQuery
    ? productsData.latest.filter(
        (product) =>
          product.artist.toLowerCase().includes(searchQuery) ||
          product.title.toLowerCase().includes(searchQuery)
      )
    : productsData.latest;

  return (
    <ProductContext.Provider value={{ popular: filteredPopular, latest: filteredLatest, filterProducts }}>
      {children}
    </ProductContext.Provider>
  );
};

export const useProducts = () => {
  const context = useContext(ProductContext);
  if (!context) {
    throw new Error('useProducts must be used within a ProductProvider');
  }
  return context;
};

export default ProductContext;